<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-row>
            <div style="position: fixed; z-index: 1;  background-color: white; width: 100%; top:55px;">
            <v-breadcrumbs :items="items" large style=" font-weight: 600; letter-spacing: 1px; ">

            </v-breadcrumbs>
            </div>
        </v-row><br><br>
        <br />
        <v-card class="card">
            <v-card-title class="heading justify-center">
                <span>Reservation Status</span>
            </v-card-title>
            <div v-if="init_loading">
          <v-skeleton-loader v-bind="attrs" type="three-line,  article"></v-skeleton-loader>
        </div>
        <div v-else>
            <v-card-text>
                <div class="add-section">
                    <div style="text-align: center;">
                        <v-col>
                            <v-form ref="form">
                                <label class="add-text">Add New Reservation Status</label><span style="color: red;"> *</span>
                                <v-text-field class="text" v-model="reservationStatus" outlined dense
                                    :rules="[rules.required]" clearable required></v-text-field>
                                <!-- <v-combobox class="text" v-model.trim="reservationStatus" :items="reservationStatus_SA" item-text="reservationStatus" outlined  dense :rules="[rules.required]" clearable required ></v-combobox> -->
                                <v-btn color="success" @click="addreservationStatus()">Add</v-btn>
                            </v-form>
                        </v-col>
                    </div>
                </div>

                <template>
                    <div class="text-center">
                        <v-dialog v-model="dialog" width="500">
                            <v-card>
                                <v-card-title class="grey lighten-2">
                                    Edit Reservation Status
                                </v-card-title>

                                <v-card-text style="padding-bottom: 0px;">
                                    <label class="add-text">Reservation Status</label><span style="color: red;"> *</span>
                                    <v-text-field class="text" v-model="reservationStatusName" outlined dense
                                        :rules="[rules.required]" clearable required></v-text-field>
                                    <!-- <v-combobox class="text" v-model.trim="reservationStatusName" :items="reservationStatus_SA" item-text="reservationStatus" outlined  dense :rules="[rules.required]" clearable required ></v-combobox> -->
                                </v-card-text>

                                <!-- <v-divider></v-divider> -->

                                <div class="text-center">
                                    <v-spacer></v-spacer>
                                    <v-btn class="m-3" @click="dialog = false">
                                        Close
                                    </v-btn>
                                    <v-btn class="m-3" @click="saveEdit()">Update</v-btn>
                                </div>
                            </v-card>
                        </v-dialog>
                    </div>
                </template>
                <div v-if="loader">
          <v-skeleton-loader v-bind="attrs" type="three-line,  article"></v-skeleton-loader>
        </div>
        <div v-else>
                <template v-if="reservationStatus_list != null">
                    <v-data-table :headers="headers" :items="reservationStatus_list" :search="search"
                        class="elevation-1 nowrap">
                        <template v-slot:top>
                            <v-toolbar flat color="white">
                                <v-spacer></v-spacer>
                                <v-text-field v-model="search" append-icon="mdi-magnify" label="Search in table" single-line
                                    hide-details></v-text-field>
                            </v-toolbar>
                        </template>
                        <template v-slot:item.edit="{ item }">
                            <!-- <v-icon v-if="item.edit==true" color="success" class="mr-2">mdi-check-circle-outline</v-icon> -->
                            <v-icon v-if="item" class="mr-2" @click="updatereservationStatus(item)">mdi
                                mdi-pencil-box</v-icon>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <!-- <v-btn :loading="edit_btn_load" @click="editItem(item)" class="link" color="info"> <v-icon title="Activate/Deactivate the User Type">mdi-recycle</v-icon></v-btn> -->
                            <v-switch v-model="item.reservationStatusIsactive" @change="editItem(item)"></v-switch>
                        </template>
                        <template v-slot:item.delete="{ item }">
                            <v-icon v-if="item" class="mr-2" @click="deleteReservationStatus(item)"> mdi mdi-delete</v-icon>
                        </template>
                    </v-data-table>
                </template>
                </div>
            </v-card-text>
            </div>
        </v-card>
        <!-- <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay> -->
    </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data: () => ({
        init_loading: false,
        loader: false,
        snackbar_msg: "",
        snackbar: false,
        color: "",
        org: null,
        dialog: false,
        search: "",
        reservationStatus: null,
        reservationStatusId: null,
        reservationStatusName: null,
        userType: null,
        reservationStatus_SA: null,
        edit_btn_load: false,
        items: [
            {
                text: 'Dashboard',
                disabled: false,
                href: '/home',
            },
            {
                text: localStorage.getItem("jhhjbyj"),
                disabled: false,
                href: '/sublink',
            },
            {
                text: 'Admin Master',
                disabled: false,
                href: '/admin-master',
            },
            {
                text: 'Reservation Status',
                disabled: true,
                href: '',
            },
        ],
        rules: {
            required: (value) => !!value || "Required.",
        },
        reservationStatus_list: null,
        headers: [
            { text: "Sr no", value: "srno" },
            { text: "Name", value: "reservationStatus" },
            { text: "Edit", value: "edit" },
            { text: "Toggle", value: "actions", sortable: false },
            { text: "Delete", value: "delete" },
        ],
    }),
    watch: {},
    methods: {
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        editItem(item) {
            console.log(item);
            this.loader = true;
            axios
                .post("/admin/reservationStatusIsactive", item)
                .then(() => {
                    this.loader = false;
                    // this.sec_mode_list = res.data.user_list;
                    this.showSnackbar("#4CAF50", "Reservation Status updated successfully...");
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    console.log(error);
                })
                .finally(() => {
                    this.loader = false;
                    this.edit_btn_load = false;
                    axios;
                });
        },

        updatereservationStatus(item) {
            this.dialog = true;
            this.reservationStatusName = item.reservationStatus;
            this.reservationStatusId = item.reservationStatusId;
        },

        saveEdit(item) {
            // if(this.reservationStatusName){
            // this.reservationStatusName = this.reservationStatusName.trim()
            // }
            console.log(item);
            const data = {
                reservationStatus: this.reservationStatusName,
                reservationStatusId: this.reservationStatusId,
            };

            this.loader = true;
            axios
                .post("/admin/editReservationStatus", data)
                .then((res) => {
                    if (res.data.code == "200") {
                        this.loader = false;
                        //this.sec_mode_list = res.data.user_list;
                        this.showSnackbar("#4CAF50", "Reservation status updated successfully...");
                        this.onload();
                        this.dialog = false;
                    } else {
                        this.loader = false;
                        this.showSnackbar("#b71c1c", res.data.msg);
                    }
                })
                .catch((error) => {
                    this.loader =false;
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    console.log(error);
                })
                .finally(() => {
                    this.loader = false;
                    this.edit_btn_load = false;
                    // this.editUserType = null;
                    axios;
                });

        },
        deleteReservationStatus(item) {
            const data = {
                reservationStatusId: item.reservationStatusId,
            };
            axios
                .post("/admin/deleteReservationStatus", data)
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.showSnackbar("#4CAF50", "Reservation Status Deleted Successfully  !!");
                        this.onload();
                    }
                    else if (res.data.msg == "exp") {
                        this.showSnackbar("#b71c1c", "Can not be Deleted!!!");
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    window.console.log(error);
                });
        },
        onload() {
            this.init_loading = true
            axios
                .post("/admin/getReservationStatus")
                .then((res) => {
                    this.org = res.data.org;
                    this.reservationStatus_list = res.data.reservationStatus;
                    // this.reservationStatus_SA = res.data.reservationStatus_SA
                    this.init_loading = false
                    //this.showSnackbar("#4CAF50","Success")
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    console.log(error);
                })
                .finally(() => {
                    this.init_loading = false
                });
        },

        addreservationStatus() {
            // if(this.reservationStatus){
            // this.reservationStatus = this.reservationStatus.trim()
            // }
            const data = {
                reservationStatus_name: this.reservationStatus,
            };

            if (this.reservationStatus) {
                this.loader = true;
                axios
                    .post("/admin/addReservationStatus", data)
                    .then((res) => {
                        this.org = res.data.org;
                        this.reservationStatus_list = res.data.reservationStatus;
                        //this.reservationStatus_list = res.data.reservationStatus_list;
                        if (res.data.code == "200") {
                            this.loader = false;
                            this.showSnackbar("#4CAF50", res.data.msg);
                            this.onload();
                            // this.showSnackbar("#4CAF50", "Reservation status added successfully...");
                            //// this.userType = null;
                            //this.$refs.form.reset()
                        } else {
                            this.loader = false;
                            this.showSnackbar("#b71c1c", res.data.msg);
                        }
                    })
                    .catch((error) => {
                        this.loader = false;
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        console.log(error);
                    })
                    .finally(() => { });
            } else {
                // this.$refs.form.validate()
                this.showSnackbar("#b71c1c", "Please enter Reservation status");
                this.$refs.form.validate()
            }
        },
    },
    mounted() {
        this.onload();
    },
};
</script>
<style scoped>
.heading {
    background-color: #3f51b5;
    padding: 0.3rem;
    color: white;
}

.v-icon {
    cursor: pointer;
}

.text>>>.v-input__slot {
    background: white !important;
    border-color: hsla(190, 99%, 30%, 1) !important;
}
</style>
